 $(document).ready(function () {
   // DISABLE APPROVE CLIENT/PILOT BUTTON UNTIL CHECKBOX(ES) CHECKED
    $('#client-requ-confirm').click(function () {
        if (!$(this).is(':checked')) {
            $('#admin-client-approve').attr('disabled', 'disabled');
        } else {
            $('#admin-client-approve').removeAttr('disabled');
        }
    });

    $('#pilot-requ-confirm, #pilot-requ-confirm2').click(function () {
        if (!$('#pilot-requ-confirm').is(':checked') || !$('#pilot-requ-confirm2').is(':checked')) {
            $('#admin-pilot-approve').attr('disabled', 'disabled');
        } else {
            $('#admin-pilot-approve').removeAttr('disabled');
        }
    });
 });